/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {filterHTML, replaceAllmatching} from "../../utils"
import '../../styles/channel/ChannelDescription.css';

class ChannelDescription extends Component {
    componentDidMount() {
        // iframe
        let iframeEles = document.querySelectorAll('.channel-description-container iframe');
        let screenWidth = window.innerWidth || screen.width;
        if (screenWidth > 480) {
            screenWidth = 480;
        }
        let iframeHeight = Math.ceil((screenWidth - 15 *2) * 9 / 16);
        if (iframeEles.length > 0) {
            for (let i = 0; i < iframeEles.length; i++) {
                iframeEles[i].height = iframeHeight + 'px';
            }
        }
    }

    render() {
        const {description} = this.props;
        const newDescription = replaceAllmatching('img.weike.fm', 'img2.lizhiweike.com', description)
        return (
            <div className="channel-description weui-padding">
                <div className="channel-description-container">
                    <pre dangerouslySetInnerHTML={{__html: filterHTML(description !== '' ? newDescription : '只有一种稳赚不赔的投资，就是学习')}}/>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    description: state.channel.channel.description,
}))(ChannelDescription)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelDescription.js